import { DocumentData } from "@king-ict/eupisi-ui/models";

import { AndragogicLeader, InstitutionLocation, OIBServiceCheckStatus } from ".";
import { Founder } from ".";
import { TownCodeBook } from "../../models/Town";
import { RoleEnum } from "../User/RoleEnum";

export interface Institution {
  id: number,
  user: string,
  userRoleId: RoleEnum
  oibServiceStatus: OIBServiceCheckStatus,
  lastModified: Date,
  name: string;
  institutionTypeId: number,
  institutionType: string,
  nameFromOib?: string;
  oib: string;
  address: string;
  addressFromOib?: string;
  email: string;
  phoneNumber: string;
  active: boolean;
  town: TownCodeBook,
  townFromOib?: TownCodeBook,
  documentCourtRegister?: DocumentData;
  documentFoundingAct?: DocumentData;
  documentUsageAgreement?: DocumentData;
  documentMinimumRequirement?: DocumentData;
  founders: Founder[];
  locations: InstitutionLocation[];
  andragogicLeaders: AndragogicLeader[];
}

export const institutionInitial = (): Institution => {
  return {
    id: 0,
    user: "",
    userRoleId: RoleEnum.None,
    lastModified: new Date(),
    name: "",
    oibServiceStatus: OIBServiceCheckStatus.Unknown,
    institutionTypeId: 0,
    institutionType: "",
    oib: "",
    address: "",
    town: { id: 0, name: "", countyId: 0, countyName: "", municipalityId: 0, municipalityName: "" },
    email: "",
    phoneNumber: "",
    active: true,
    documentCourtRegister: undefined,
    documentFoundingAct: undefined,
    documentMinimumRequirement: undefined,
    founders: [],
    locations: [],
    andragogicLeaders: []
  }
}